angular.module('NumbersEditor').directive('manufacturerWeightValidate', function () {
    return {
        // restrict to an attribute type.
        restrict: 'A',

        // element must have ng-model attribute.
        require: 'ngModel',

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function (scope, elem, attr, ctrl) {

            scope.$on("kickOffValidations", function (event, args) {

                var manufacturerBalls = Enumerable.From(scope.EventExtraInfo.ManufacturerBallSets)
                   .Where(function (i) {
                       return i.Name === scope.SelectedBallSet;
                   })
                   .Select("$.ManufacturerBalls")
                   .ToArray()[0];

                var x = Enumerable.From(manufacturerBalls)
                       .Where(function (i) {
                           return i.BallNumber === parseInt(attr.id);
                       }).ToArray();

                if (x.length === 1) {
                    var manufacturerweight = parseFloat(x[0].ManufacturerWeight);
                    var maxValue = manufacturerweight + 0.5;
                    var minValue = manufacturerweight - 0.5;
                    var value = ctrl.$viewValue;

                    if (parseFloat(value) < minValue) {
                        ctrl.$setValidity("min", false);
                    } else {
                        ctrl.$setValidity("min", true);
                    }

                    if (parseFloat(value) > maxValue) {
                        ctrl.$setValidity("max", false);
                    }
                    else {
                        ctrl.$setValidity("max", true);
                    }
                    $("#" + attr.id).attr("min", minValue);
                    $("#" + attr.id).attr("max", maxValue);
                }
            });



            // add a parser that will process each time the value is 
            // parsed into the model when the user updates it.
            ctrl.$parsers.unshift(function (value) {
                /*  var manufacturerBalls = Enumerable.From(scope.EventExtraInfo.ManufacturerBallSets)
                .Where(function (i) {
                    return i.Name === scope.SelectedBallSet;
                })
                .Select("$.ManufacturerBalls")
                .ToArray()[0];
  
                  var x = Enumerable.From(manufacturerBalls)
                         .Where(function (i) {
                             return i.BallNumber === parseInt(attr.id);
                         }).ToArray();
  
                  if (x.length === 1) {
                      var manufacturerweight = parseFloat(x[0].ManufacturerWeight);
                      var maxValue = manufacturerweight + 0.5;
                      var minValue = manufacturerweight - 0.5;
  
                      if (parseFloat(value) < minValue) {
                          ctrl.$setValidity("min", false);
                      } else {
                          ctrl.$setValidity("min", true);
                      }
  
                      if (parseFloat(value) > maxValue) {
                          ctrl.$setValidity("max", false);
                      }
                      else {
                          ctrl.$setValidity("max", true);
                      }
                      $("#" + attr.id).attr("min", minValue);
                      $("#" + attr.id).attr("max", maxValue);
                  }*/
                return value;
            });

            // add a formatter that will process each time the value 
            // is updated on the DOM element.
            ctrl.$formatters.unshift(function (value) {
                // validate.
                //ctrl.$setValidity('regexValidate', regex.test(value));
                /*if (isNaN(value)) {
                    ctrl.$setValidity('manufacturerweight', false);
                }*/



                /*ctrl.$setValidity("manufacturerweight", true);
                if (isNaN(value) === true) {
                    ctrl.$setValidity("manufacturerweight", false);
                }*/



                // return the value or nothing will be written to the DOM.
                return value;
            });
        }
    };
});